import { useNavigate } from "react-router-dom";
import AppBar from "../../components/atoms/appbar";
import { vw } from "../../lib/utils/responsiveUtils";
import { useQuery } from "@tanstack/react-query";
import {
  useAlarmApplyList,
  useReadAllNotifications,
} from "../../@apis/hooks/useSetting"; // 경로 확인
import { timeAgo } from "../../lib/utils/dateUtils";

export default function Alarm() {
  const navigate = useNavigate();

  // 알림 목록 불러오기
  const { data } = useQuery({ ...useAlarmApplyList() });
  const alarms = data?.data.notificationList ?? [];

  // 모두 읽음 처리 훅 — 완료 대기하려고 mutateAsync 사용
  const { mutateAsync: markAllRead } = useReadAllNotifications();

  // 뒤로가기 시 → 모두 읽음 처리(서버 반영 완료 후 이동)
  const handleBack = async () => {
    await markAllRead(); // PUT 성공까지 대기 → 서버가 isNew=false 저장
    navigate(-1); // 그 다음 이전 페이지로 이동
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <AppBar backButton title="알림" onBack={handleBack} />

      {/* 리스트 영역 */}
      <section className="flex-1 px-[15px] space-y-[15px] flex flex-col">
        {alarms.length > 0 ? (
          alarms.map((item) => (
            <div
              key={item.id}
              className="relative w-full text-left bg-[#f5f5f5] rounded-[10px] py-[15px] px-[20px] flex items-center"
            >
              {/* 빨간 점 */}
              {item.isNew && (
                <span className="absolute top-[9px] right-1 w-[9px] h-[9px] rounded-full bg-[#e5002b] translate-x-1/2 -translate-y-1/2" />
              )}

              {/* 텍스트 영역 */}
              <div className="flex-1 flex flex-col">
                <p className="mb-[14px] text-[#888] leading-[150%] text-sm">
                  {timeAgo(item.updateDt)}
                </p>
                <p className="leading-[150%] font-semibold  text-[#222]">
                  {item.message}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="flex flex-1 flex-col items-center justify-center text-[#ccc]">
            <img
              src={"/icons/ic-notice.webp"}
              alt="공지 이미지"
              className="mb-[14px]"
              style={{ width: vw(48), height: vw(48) }}
            />
            <p>알림 내역이 없습니다.</p>
          </div>
        )}
      </section>
    </div>
  );
}
